"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRCType = void 0;
var PRCType;
(function (PRCType) {
    PRCType["cycle"] = "cycle";
    PRCType["process"] = "process";
    PRCType["risk"] = "risk";
    PRCType["control"] = "control";
})(PRCType = exports.PRCType || (exports.PRCType = {}));
//# sourceMappingURL=PRC.js.map